import { render } from "./CategoryTags.vue?vue&type=template&id=623067fd"
import script from "./CategoryTags.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/labelinsight-products/components/filter/CategoryTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "623067fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('623067fd', __exports__)) {
    api.reload('623067fd', __exports__)
  }
  
  module.hot.accept("./CategoryTags.vue?vue&type=template&id=623067fd", () => {
    api.rerender('623067fd', render)
  })

}


export default __exports__